import { getMissionStatus } from "../utils/utils"
import { differenceInCalendarDays } from "date-fns/differenceInCalendarDays"
import { isWithinInterval } from "date-fns/isWithinInterval"
import { findAiEndDate } from "../utils/dates"
import { toZonedTime } from "date-fns-tz"

import { startOfWeek, endOfWeek } from "date-fns"

// Past this many days late a task is treated as abandoned and left off Home.
const STALE_OVERDUE_DAYS = 20

// How pressing a task is, from the days until it ends (negative = late).
// Recently late work comes first, then today, then tapering out to a month away.
function urgency(daysLeft) {
    if (daysLeft < -STALE_OVERDUE_DAYS) return null
    if (daysLeft < -7) return 8
    if (daysLeft < 0) return 16
    if (daysLeft === 0) return 14
    if (daysLeft === 1) return 11
    if (daysLeft <= 3) return 9
    if (daysLeft <= 7) return 6
    if (daysLeft <= 14) return 4
    if (daysLeft <= 28) return 2

    return 1
}

export function recommender(missions, app, actionItems, date) {
    const myMissions = missions.filter((m) => {
        if (!m.kickedOff || m.isTemplate || m.isModel) {
            return false
        }

        const status = getMissionStatus(m)

        let isWithin

        try {
            isWithin = isWithinInterval(date, {
                start: startOfWeek(toZonedTime(m.planStartDate), { weekStartsOn: 1 }),
                end: endOfWeek(toZonedTime(m.planEndDate), { weekStartsOn: 1 }),
            })
        } catch (e) {
            app.silentFail(`weo3r43i8883-2-mission${m?._id}`)
            return false
        }

        if (status !== "active" || m.isModel || m.isTemplate || !isWithin) {
            return false
        }

        return true
    })

    const missionMap = new Map(myMissions.map((m) => [m._id, m]))

    const weightedActionItems = actionItems
        .map((ai) => {
            const mission = missionMap.get(ai.missionId)
            if (!mission) {
                return null
            }

            const endDate = findAiEndDate(ai, mission)
            const daysLeft = endDate ? differenceInCalendarDays(endDate, date) : null

            let weight = daysLeft === null ? 1 : urgency(daysLeft)

            if (weight === null) {
                return null
            }

            if (mission.client) {
                weight += 2
            }

            // metaType 0 = flagged critical on the task screen
            if (ai.metaType === 0) {
                weight *= 2.5
            }

            // Still worth seeing, but not ahead of work that can move today
            if (ai.status === "blocked") {
                weight *= 0.5
            }

            return { ...ai, weight, endTime: endDate ? endDate.getTime() : Infinity }
        })
        .filter(Boolean)

    return weightedActionItems.sort((a, b) => b.weight - a.weight || a.endTime - b.endTime)
}
